import React from 'react';
import StatisticsCard from '../../../pages/user-profile-dashboard/components/StatisticsCard';

const Row = ({ label, value }) => {
  return (
    <div className="flex items-center justify-between px-3 py-2">
      <span className="text-xs text-muted-foreground caption">{label}</span>
      <span className="text-sm font-bold text-foreground data-text">{value}</span>
    </div>
  );
};

const DestimeStatsCards = ({ destimeStats, formatDuration }) => {
  return (
    <>
      <div className="sm:hidden bg-card rounded-lg shadow-gaming-md border border-border overflow-hidden">
        <div className="divide-y divide-border">
          <Row label="오늘 인증 사용 시간" value={formatDuration(destimeStats?.todayMinutes)} />
          <Row label="이번 주 인증 사용 시간" value={formatDuration(destimeStats?.weekMinutes)} />
          <Row label="이번 달 인증 사용 시간" value={formatDuration(destimeStats?.monthMinutes)} />
        </div>
      </div>

      <div className="hidden sm:grid grid-cols-1 md:grid-cols-3 gap-2 sm:gap-3 md:gap-6">
        <StatisticsCard
          icon="Clock"
          label="오늘 인증 사용 시간"
          value={formatDuration(destimeStats?.todayMinutes)}
          trend="neutral"
          trendValue="0"
          color="primary"
        />
        <StatisticsCard
          icon="Calendar"
          label="이번 주 인증 사용 시간"
          value={formatDuration(destimeStats?.weekMinutes)}
          trend="neutral"
          trendValue="0"
          color="accent"
        />
        <StatisticsCard
          icon="CalendarDays"
          label="이번 달 인증 사용 시간"
          value={formatDuration(destimeStats?.monthMinutes)}
          trend="neutral"
          trendValue="0"
          color="warning"
        />
      </div>
    </>
  );
};

export default DestimeStatsCards;
